import React, { Suspense } from 'react';
import { Router, Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Provider } from "inversify-react";
import { observer } from "mobx-react";

import { RootStore } from "./stores";

import IndexPage from "./pages/IndexPage";
import ProfilePage from "./pages/ProfilePage";
import AssetsPage from "./pages/AssetsPage";
import OTCPage from "./pages/OTCPage";
import ExchangePage from "./pages/ExchangePage";

import { Modals } from "./modals";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import { SVGSprite } from "./components/SVGSprite";
import { API_HOST } from './utils/const';

export const rootStore = new RootStore();
const container = rootStore.container

const Environments = {
    'maxbit': 'Maxbit',
    'teletrade': 'TeleTrade'
}

const EnvironmentsFavicon = {
    'maxbit': 'favicon-maxbit.ico',
    'teletrade': 'favicon-teletrade.ico'
};

@observer
class Application extends React.Component {
    componentDidMount() {
        const link = document.querySelector('link[rel="icon"]');

        if (link) {
            link.setAttribute('href', `./images/${EnvironmentsFavicon[API_HOST.split('.')[0]]}`);
        }
    }

    render() {
        if (!rootStore.authStore.initialized)
            return (
                <div>
                    Loading...
                </div>
            );
        return (
            <Provider container={container}>
                <Router history={rootStore.historyStore}>
                    <title>
                        {
                            Environments[API_HOST.split('.')[0]]
                        }
                    </title>
                    <ToastContainer/>
                    <Header />
                    <Switch>
                        <Route exact path='/' component={IndexPage} />
                        <ProtectedRoute exact path='/profile' component={ProfilePage} />
                        <ProtectedRoute path='/assets' component={AssetsPage} />
                        <ProtectedRoute path='/p2p' component={OTCPage} />
                        <ProtectedRoute path='/exchange' component={ExchangePage} />
                    </Switch>
                    <Footer />
                    <Modals />
                    <SVGSprite />
                </Router>
            </Provider>
        );
    }
}

function WrappedApp() {
    
    return (
        <Suspense fallback="...loading">
            <Application/>
        </Suspense>
    );
}

export default WrappedApp;
